import { KeyboardEventHandler, useEffect, useRef } from 'react';
import styles from './SubItem.module.scss';
import PureLink from '../Link/PureLink';
import { SubItemProps } from './MenuItem.types';

const noAction = () => {};

const SubItem = ({ label, link, keyboardEventHandler, focusActive = false, onClick = noAction }: SubItemProps) => {
  const linkRef = useRef<HTMLAnchorElement>(null);

  const handleKeyDown: KeyboardEventHandler<HTMLAnchorElement> = event => {
    keyboardEventHandler?.(event);
  };

  useEffect(() => {
    if (focusActive) {
      linkRef.current?.focus();
    }
  }, [focusActive]);

  return (
    <li className={styles.subItem}>
      <PureLink className={styles.subItemLink} href={link} ref={linkRef} onKeyDown={handleKeyDown} onClick={onClick}>
        {label}
      </PureLink>
    </li>
  );
};

export default SubItem;
